import React, { useContext, useState } from "react";
import AssetTable from "../../components/asset/AssetTable";
import AppContext from "../../context/AppContext";
import translations from "../../components/common/Translations";

const AssetList = () => {
  // const [openTab, setOpenTab] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const { theme, langMode, openTab, setOpenTab } = useContext(AppContext);
  return (
    <div className=" w-full">
      <h4
        className={`uppercase ml-[10px] font-semibold whitespace-nowrap text-gray-800 ${
          theme === "dark"
            ? "dark-mode"
            : theme === "high-contrast"
            ? "high-contrast  "
            : ""
        }`}
      >
        {translations[langMode].asset}
      </h4>
      <div
        className={`px-5 w-full overflow-y-auto h-[550px] bg-white p-4 ${
          theme === "dark"
            ? "dark-mode  "
            : theme === "high-contrast"
            ? "high-contrast  "
            : ""
        }`}
      >
        <div className="inline-flex rounded-sm shadow-sm">
          <button
            onClick={() => setOpenTab(1)}
            className={` px-4 py-2 text-sm font-medium flex items-center gap-2 ${langMode === 'ar' ? ' rounded-r-lg ':' rounded-l-lg' }  focus:ring-2 focus:ring-blue-700 transition-all ${
              openTab === 1
                ? "bg-[#236DB4] text-white"
                : "bg-gray-200 text-gray-600"
            } ${
              theme === "dark"
                ? "dark-mode  "
                : theme === "high-contrast"
                ? "high-contrast  "
                : ""
            }`}
          >
            {translations[langMode].vehical}
          </button>
          <button
            onClick={() => setOpenTab(2)}
            className={`px-4 py-2 text-sm font-medium flex items-center gap-2 ${langMode === 'ar' ? 'rounded-l-md ':'rounded-r-md' }   focus:ring-2 focus:ring-blue-700 transition-all ${
              openTab === 2
                ? "bg-[#236DB4] text-white"
                : "bg-gray-200 text-gray-600"
            } ${
              theme === "dark"
                ? "dark-mode  "
                : theme === "high-contrast"
                ? "high-contrast  "
                : ""
            }`}
          >
            {translations[langMode].Inventory}
          </button>
        </div>
        <div style={{ display: openTab === 1 ? "block" : "none" }}>
          <AssetTable
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            tab={1}
            tableHeaders={[
              translations[langMode].vehicleId,
              translations[langMode].vehicalType,
              translations[langMode].vehicleKM,
              translations[langMode].vehicleAssinged,
            ]}
          />
        </div>
        <div style={{ display: openTab === 2 ? "block" : "none" }}>
          <AssetTable
            tab={2}
            tableHeaders={[
              translations[langMode].assetId,
              translations[langMode].AssetName,
              translations[langMode].assetBarCode,
              translations[langMode].assetType,
              translations[langMode].agentAssigned,
              translations[langMode].assetStatus,
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default AssetList;
